import { Tooltip } from "@mui/material";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { FISCALIZATION_ERROR, FISCALIZATION_SUCCESS } from "../../utils/listitem";
import { useTranslation } from "react-i18next";



const FiscalizationState = ({ fiscalizationState }) => {
    const { t } = useTranslation();

    let color = "background.grey500";
    if (fiscalizationState === FISCALIZATION_SUCCESS) {
        color = "secondary.main";
    } else if (fiscalizationState === FISCALIZATION_ERROR) {
        color = "error.main"
    }
    return <Tooltip title={t("FISCALIZATION_STATE") + ' - ' + t(fiscalizationState)}>
        <ReceiptLongIcon sx={{ color }} />
    </Tooltip>
}

export default FiscalizationState;
